<template>
    <v-card width="100%">
        <v-card-title>
            <span>Настройка параметров Медиастанции</span>
        </v-card-title>
        <v-card-text>
            <v-row>
                <v-col cols="2">
                    <v-checkbox label="DLNA" v-model="dlna" @change="dlnaChange"/>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    name: "mediastationSettings",
    data() {
        return {
            dlna: false
        }
    },
    created() {
        this.getPlexSettings()
    },
    methods: {
        getPlexSettings() {
            this.$http.get('/getPlexSettings').then((resp) => {
                this.dlna = resp.data.dlna
            })
        },
        dlnaChange() {
            this.$http.post('dlnaChange', {
                dlna: this.dlna
            })
        }
    }
}
</script>

<style scoped>

</style>